import {Ref, ref} from "@vue/composition-api";

type Resolve = (response: any) => any;

export class FormConfig {
    public searchName: string;
    public filters: Array<Filter>
    public actions: Array<Action>;
    public functionButtons: Array<FunctionButton>;
    public convertResponse: Resolve
    public editBtn: boolean
    public addBtn: boolean
    public deleteBtn: boolean

    constructor(
        public readonly data: Ref<any>,
        public readonly configs: Array<PropertyConfig>,
        public readonly entity: string,
    ) {
        this.data = data
        this.configs = configs
        this.entity = entity;
        this.convertResponse = a => {
            return a;
        }
        this.editBtn = true;
        this.addBtn = true
        this.deleteBtn = true;
    }

    resolve(res: any) {
        return this.convertResponse(res);
    }

    withSearchName(searchName: string) {
        this.searchName = searchName;
        return this;
    }

    withFilters(filters: Array<Filter>) {
        this.filters = filters;
        return this;
    }

    withFunctionButtons(buttons: Array<FunctionButton>) {
        this.functionButtons = buttons;
        return this;
    }

    withActions(actions: Array<Action>) {
        this.actions = actions;
        return this;
    }

    toFilterStr(searchValue: string): string {
        let ft = [];
        if (this.filters != null) {
            ft = this.filters.map(f => {
                return f.toInternalFilter();
            });
        }
        if (searchValue != "") {
            ft.push(new InternalFilter(this.searchName, "cn", searchValue))
        }
        if (ft.length == 0) {
            return null;
        }
        const fs = JSON.stringify(ft);
        return `{"groupOp":"AND","rules":${fs}}`;
    }


}

const SERVER_OP = [
    "eq",
    "gt",
    "ge",
    "lt",
    "le",
    "cn",
]

export class FunctionButton {
    constructor(
        public readonly text: string,
        public readonly action: string,
        public readonly successMsg: string,
    ) {
        this.text = text
        this.action = action
        this.successMsg = successMsg;
    }
}

export class Action {
    public routerKey: string
    public extraPara: Object


    constructor(
        public readonly text: string,
        public readonly action: string,
    ) {
        this.text = text
        this.action = action
        this.routerKey = null
    }

    generateRouterParam(id: any) {
        if (this.routerKey == null) {
            return {"id": id};
        } else {
            let param = {}
            param[this.routerKey] = id;
            return param;
        }
    }

    withRouterKey(routerKey: string) {
        this.routerKey = routerKey
        return this;
    }

    withExtraPara(extraPara: Object) {
        this.extraPara = extraPara
        return this;
    }
}

class InternalFilter {

    constructor(
        public readonly field: string,
        public readonly op: string,
        public readonly data: any,
    ) {
        this.field = field
        this.data = data
        this.op = op
    }
}

export class Filter {
    // public type: FieldType
    // public name: string
    // public label: string
    // public operator: Operator
    public refs: Ref<Array<any>>
    public value: Ref<any>
    public hidden: boolean


    constructor(
        public readonly name: string,
        public readonly label: string,
        public readonly type: FieldType,
        public readonly operator: Operator,
    ) {
        this.name = name
        this.label = label
        this.type = type
        this.operator = operator;
        this.value = ref(null)
        this.hidden = false;
    }

    toInternalFilter(): InternalFilter {
        return new InternalFilter(this.name, SERVER_OP[this.operator], this.value.value)
    }

    withValue(value: Ref<any>) {
        this.value = value
        return this;
    }

    withRef(ref: Ref<Array<any>>) {
        this.refs = ref
        return this;
    }

    withHidden(hidden: boolean) {
        this.hidden = hidden
        return this;
    }
}

export enum FieldType {
    TEXT, PASSWORD, SELECT, SELECT_ARRAY, RADIO, DATE, EMAIL, NUMBER, TEXTAREA, SWITCH, HIDE, CK_IMAGE, MULTIPLE, FREEMARKER
}

export enum Operator {
    EQ, GT, GE, LT, LE, CN
}


export class PropertyConfig {
    public refs: Ref<Array<any>>
    public defaultValue: Ref<any>
    public hideInList: boolean
    public action: string;
    public sortable: boolean
    public cols: string
    public md: string


    constructor(
        public readonly name: string,
        public readonly label: string,
        public readonly type: FieldType,
    ) {
        this.name = name
        this.label = label
        this.type = type
        this.refs = null;
        this.action = null;
        this.hideInList = false;
        this.sortable = true
        this.cols = "12"
        this.md = "4"
    }

    withAction(action: string) {
        this.refs = ref([])
        this.action = action;
        return this;
    }

    withSortable(sortable: boolean) {
        this.sortable = sortable
        return this;
    }

    withHideInList(hide: boolean) {
        this.hideInList = hide;
        return this;
    }

    withDefaultValue(ref: Ref<any>) {
        this.defaultValue = ref
        return this;
    }

    withRef(ref: Ref<Array<any>>) {
        this.refs = ref
        return this;
    }

}
